// Shared formatting/ID helpers for the SmartEstimator module.
export const money = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Format a service/line default price. Renders null / undefined / "" as an
// em-dash so users clearly see "not configured" instead of a misleading $0.
// Legitimate numeric 0 is still rendered as $0 (a business may intentionally
// set a service to free).
export const priceOrDash = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const pct = (n) => `${Number(n || 0).toFixed(1)}%`;
export const genLineId = () => `line_${Math.random().toString(36).slice(2, 10)}`;
